export default __webpack_public_path__ + "static/media/warning--accident-area--g5.78034bb3.png";